import ManageSettings from '@/pages/ManageSettings'

export default {
    path: '/manage/settings',
    name: 'Manage Settings',
    component: ManageSettings
  }


// WEBPACK FOOTER //
// ./src/router/managesettings.js